import React from 'react';
import {
    ApplyNowFormValues,
    IApplyNowForm,
    IApplyNowCandidateInformationForm,
    IApplyNowReferrerInformationForm,
    IApplyNowAdditionalQuestionsForm,
    IRejectApplicationForm,
    RejectApplicationFormValues,
    ISendEmailForm,
    SendEmailFormFields,
} from '../interfaces';
import { IOption } from '../../base';
import i18next from 'i18next';

export const emptyApplyNowForm: IApplyNowForm = {
    [ApplyNowFormValues.firstName]: '',
    [ApplyNowFormValues.lastName]: '',
    [ApplyNowFormValues.phoneNumber]: '',
    [ApplyNowFormValues.email]: '',
    [ApplyNowFormValues.file]: null,
    [ApplyNowFormValues.acceptTerms]: false,
};

export const emptyApplyNowCandidateInformationForm: IApplyNowCandidateInformationForm = {
    [ApplyNowFormValues.firstName]: '',
    [ApplyNowFormValues.lastName]: '',
    [ApplyNowFormValues.phoneNumber]: '',
    [ApplyNowFormValues.email]: '',
    [ApplyNowFormValues.file]: null,
    [ApplyNowFormValues.isReferrer]: false,
};

export const emptyApplyNowReferrerInformationForm: IApplyNowReferrerInformationForm = {
    [ApplyNowFormValues.referrerName]: '',
    [ApplyNowFormValues.referrerLastName]: '',
    [ApplyNowFormValues.referrerEmail]: '',
    [ApplyNowFormValues.referrerPhoneNumber]: '',
    [ApplyNowFormValues.referrerCompany]: '',
    [ApplyNowFormValues.coverLetter]: '',
};

export const emptyApplyNowAdditionalQuestionsForm: IApplyNowAdditionalQuestionsForm = {
    [ApplyNowFormValues.acceptTerms]: false,
    [ApplyNowFormValues.questionAnswers]: [],
};

export const emptyRejectApplicationForm: IRejectApplicationForm = {
    [RejectApplicationFormValues.reasonOption]: null,
    [RejectApplicationFormValues.reasonText]: null,
};

export const emptySendEmailForm: ISendEmailForm = {
    [SendEmailFormFields.to]: '',
    [SendEmailFormFields.cc]: [],
    [SendEmailFormFields.bcc]: [],
    [SendEmailFormFields.from]: '',
    [SendEmailFormFields.subject]: '',
    [SendEmailFormFields.body]: '',
};

export const borderlessInputSx = {
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '& .MuiOutlinedInput-root, & .MuiInputBase-root.MuiInputBase-sizeSmall': {
        padding: 0,
        height: 'auto',
    },
    '& .MuiInputBase-input.MuiOutlinedInput-input': {
        padding: '4px 0',
        fontSize: 14,
    },
    '& .MuiFormHelperText-root': {
        display: 'none',
    },
} as React.CSSProperties;

export enum JobApplicationStatuses {
    new = 'NEW',
    declined = 'DECLINED',
    inReview = 'IN_REVIEW',
    withdrawn = 'WITHDRAWN',
    hired = 'HIRED',
}

export enum JobApplicationStatusUpdateValues {
    reject = 'REJECT',
    accept = 'ACCEPT',
    withdraw = 'WITHDRAW',
    inProcess = 'IN_PROCESS',
    none = 'NONE',
}

export enum RequirementLevels {
    mandatory = 'MANDATORY',
    advantage = 'ADVANTAGE',
    regular = 'REGULAR',
}

export const jobApplicationStatusesOptions: Array<IOption> = [
    {
        key: JobApplicationStatuses.new,
        label: i18next.t(`statuses.${JobApplicationStatuses.new}`),
        value: JobApplicationStatuses.new,
    },
    {
        key: JobApplicationStatuses.inReview,
        label: i18next.t(`statuses.${JobApplicationStatuses.inReview}`),
        value: JobApplicationStatuses.inReview,
    },
    {
        key: JobApplicationStatuses.hired,
        label: i18next.t(`statuses.${JobApplicationStatuses.hired}`),
        value: JobApplicationStatuses.hired,
    },
    {
        key: JobApplicationStatuses.withdrawn,
        label: i18next.t(`statuses.${JobApplicationStatuses.withdrawn}`),
        value: JobApplicationStatuses.withdrawn,
    },
    {
        key: JobApplicationStatuses.declined,
        label: i18next.t(`statuses.${JobApplicationStatuses.declined}`),
        value: JobApplicationStatuses.declined,
    },
];

export enum JobApplicationsTableFilterIds {
    score = 'score',
    status = 'status',
    publishedDate = 'published_date',
    minScore = 'min_score',
    maxScore = 'max_score',
    jobId = 'job_id',
    isSavedForLater = 'is_saved',
    dateFrom = 'date_from',
    dateTo = 'date_to',
    tags = 'tags',
    source = 'source',
}

export enum JobApplicationTrailActionTypes {
    comment = 'COMMENT',
    stageChange = 'STAGE_CHANGE',
    statusChange = 'STATUS_CHANGE',
    rejected = 'REJECTED',
    withdrew = 'WITHDREW',
    noteAdded = 'NOTE_ADDED',
    hired = 'HIRED',
    interviewScheduled = 'INTERVIEW_SCHEDULED',
    interviewUpdated = 'INTERVIEW_UPDATED',
    interviewDeleted = 'INTERVIEW_DELETED',
    lifecycleChange = 'LIFECYCLE_CHANGE',
}

export enum JobApplicationTrailRelatedObjectTypes {
    comment = 'comment',
    step = 'step',
}

export const DAY_NAMES = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
] as const;
